import FormatValue from 'assets/components/formatValue/FormatValue';
import Icon from 'assets/components/icon/Icon';
import { getLocales } from 'assets/locales/Locale';
import Sidebar from 'assets/templates/sidebar/Sidebar';
import { defaultDateTimeFormat, localizeDate } from 'assets/utils/data/Date';
import PaymentType from 'models/enums/PaymentType';
import { ContractRefundPaymentItemAction, useContractRefundPaymentItemProvider } from '../Finance.ContractRefundPaymentItem.Hooks';

export default function ContractRefundPaymentItemInfo() {
  const { lang, translate } = getLocales();
  const { selected, pageRouter } = useContractRefundPaymentItemProvider();

  const dealerPaymentControl = selected?.contractRefundDealerPaymentControl;
  const dealerPaymentControlPayee = dealerPaymentControl?.contractRefundPayee ?? selected?.contractRefundPayee;
  const dealerPaymentControlPayeeType = !dealerPaymentControlPayee
    ? lang.notAvailable
    : dealerPaymentControlPayee.dealer || dealerPaymentControlPayee.dealerId
      ? lang.dealer
      : dealerPaymentControlPayee.lender || dealerPaymentControlPayee.lenderId
        ? lang.lender
        : dealerPaymentControlPayee.client || dealerPaymentControlPayee.clientId
          ? lang.client
          : lang.payee;

  return !selected || pageRouter.params?.action !== ContractRefundPaymentItemAction.INFO ? null : (
    <Sidebar
      onClose={() => pageRouter.updateParams({})}
      icon={<Icon class="if-database" />}
      title={
        <>
          {lang.contractRefund} #: <b>{selected.jobId}</b>
        </>
      }
      content={
        <>
          <h3>{lang.info}</h3>
          <div>
            {lang.paymentMethod}:{' '}
            <b>{translate(Object.values(PaymentType).find((it) => it === selected.paymentMethodCode))}</b>
          </div>
          <div>
            {lang.payeeName}: <b>{selected.contractRefundPayee?.displayInfo?.title ?? 'N/A'}</b>
          </div>
          <div>
            {lang.createdBy}: <b>{selected.createdBy?.fullName ?? 'N/A'}</b>
          </div>
          <div>
            {lang.createdAt}:{' '}
            <b>{selected.createdAtLocal ? localizeDate(selected?.createdAtLocal, defaultDateTimeFormat) : 'N/A'}</b>
          </div>

          <h3>{lang.prices}</h3>
          <div>
            {lang.amount}:{' '}
            <b>
              <FormatValue value={`${(selected.totalAmountBeforeTax || 0).toFixed(2)}$`} />
            </b>
          </div>
          <div>
            {lang.gstHstPaid}:{' '}
            <b>
              <FormatValue value={`${(selected.gstHstAmount || 0).toFixed(2)}$`} />
            </b>
          </div>
          <div>
            {lang.pstPaid}:{' '}
            <b>
              <FormatValue value={`${(selected.provincialSalesTaxAmount || 0).toFixed(2)}$`} />
            </b>
          </div>
          <hr />
          <div>
            {lang.total}:{' '}
            <b>
              <FormatValue value={`${(selected.totalAmount || 0).toFixed(2)}$`} />
            </b>
          </div>

          <h3>{lang.dealerPaymentControls}</h3>
          <div>
            {lang.payee}: <b>{dealerPaymentControlPayee?.displayInfo?.title ?? lang.notAvailable}</b>
          </div>
          <div>
            {lang.payeeType}: <b>{dealerPaymentControlPayeeType}</b>
          </div>
          <div>
            {lang.fundingSource}: <b>{translate(dealerPaymentControl?.fundingSourceCode)}</b>
          </div>
          <div>
            {lang.responsibilityType}: <b>{translate(dealerPaymentControl?.responsibilityTypeCode)}</b>
          </div>
          <div>
            {lang.paymentPurpose}: <b>{translate(dealerPaymentControl?.paymentPurposeCode)}</b>
          </div>
          <div>
            {lang.accountingItemType}: <b>{translate(dealerPaymentControl?.accountingItemTypeCode)}</b>
          </div>
          <hr />
          <div>
            {lang.allocatedAmount}:{' '}
            <b>
              <FormatValue value={`$${dealerPaymentControl?.allocatedAmountCAD ?? 0}`} />
            </b>
          </div>
        </>
      }
    />
  );
}
